<h2 style="text-align:center">First Meeting Form</h2>
<router-outlet *ngIf="!loading" name="meeting_1"></router-outlet>

 
<survey-project-meeting *ngIf="auth.isProject() || auth.isAdmin() || auth.isProjectBoard() || auth.isCallManager() " [step]="1"></survey-project-meeting>

